import { gsap } from 'gsap/dist/gsap';

/**************************************************************
-> Open/close and handle interactivity witin plus plan lightbox
**************************************************************/
export function triggerPlusPlanLightbox() {
  const button = document.querySelector('.button-plus-plan')

  if (button) {

    button.addEventListener('click', () => {
      const lightbox = document.querySelector('[data-lightbox-plus-plan]')
      const lightboxContainer = lightbox.querySelector('[data-container]')
      const close = lightbox.querySelector('[data-lightbox-close]')
      const nextButton = lightbox.querySelector('.teams-next-button')
      const buttonContainer = lightbox.querySelector('.button-container')
      const teamNameInput = lightbox.querySelector('input[type="text"]')
      
      document.body.style.overflow = 'hidden'
      gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
      gsap.to(lightboxContainer, { y: 0, delay: 0.3 })
      
      close.addEventListener('click', () => {
        document.body.style.overflow = 'initial'
        gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
        gsap.to(lightboxContainer, { y: '25px' })
      })

      teamNameInput.addEventListener('input', () => {
        if (teamNameInput.value.length > 0) {
          nextButton.classList.remove('opacity-50')
          nextButton.classList.add('opacity-100')
          nextButton.classList.remove('pointer-events-none')
          buttonContainer.classList.remove('cursor-not-allowed')
        } else {
          nextButton.classList.add('opacity-50')
          nextButton.classList.remove('opacity-100')
          nextButton.classList.add('pointer-events-none')
          buttonContainer.classList.add('cursor-not-allowed')
        }
      });
    })
  }
}

/**************************************************************
-> Configure the +/- buttons for the user count
**************************************************************/
export function numberOfUsersControl() {
  const lightbox = document.querySelector('[data-lightbox-plus-plan]')

  if (lightbox) {
    const decrementButton = lightbox.querySelector('[data-button-decrement]')
    const incrementButton = lightbox.querySelector('[data-button-increment]')
    const input = lightbox.querySelector('input[type=number]')

    incrementButton.addEventListener('click', () => {
      if (input.value <= 49 ) {
        input.value++
      } else {
        alert('50 users is the maximum for the Plus plan')
      }
    })
    
    decrementButton.addEventListener('click', () => {
      if (input.value > 2) {
        input.value--
      } else {
        alert('2 users is the the minimum for the Plus plan')
      }
    })
  }
}

/**************************************************************
-> Create the team plan URL for the WooCommerce checkout
-> based on the user input
**************************************************************/
export function createPlusPlanCheckout() {
  const lightbox = document.querySelector('[data-lightbox-plus-plan]')

  if (lightbox) {
    const nextButton = lightbox.querySelector('.teams-next-button')
    const teamNameInput = lightbox.querySelector('input[type=text]')
    const quantityInput = lightbox.querySelector('input[type=number]')
    
    nextButton.addEventListener('click', () => {
      const teamName = teamNameInput.value
      const quantity = quantityInput.value
      let variableProductId

      if (quantity >= 2 && quantity <= 5) {
        variableProductId = 4838
      } else if (quantity >= 6 && quantity <= 10) {
        variableProductId = 4839
      } else if (quantity >= 11 && quantity <= 50) {
        variableProductId = 4840
      }
      window.location.replace(`/cart/?add-to-cart=${variableProductId}&quantity=${quantity}&team_name=${teamName}`)
      
    })
  }
}


// WEBPACK FOOTER //
// ./scripts/components/pricing-table.js